/**
 * 通讯录
 * Bai.Zhiming
 * 2019-7-11
 */
angular.module("chatDirectoryModule", [
    'C2CDirectoryModule',
    'groupDirectoryModule'
]).
directive("chatDirectory", [function() {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "./IM/chatWindow/chatDirectory/chatDirectory_tpl.html",
        scope: {
            fn: "=",
            loginInfo: "="
        },
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [switchNav description] 切换通讯录导航
             * @param  {[type]} navName [description] 导航名称
             * @return {[type]}         [description]
             */
            scope.switchNav = function(navName) {
                if (scope.status[navName + 'Show']) {
                    scope.status.reoladData = `${navName}_${Math.round(Math.random()*1e14)}`;
                }
                scope.status[navName + 'Load'] = true;
                scope.status[navName + 'Show'] = true;
                let anotherNav = navName == 'c2cDirectory' ? 'groupDirectory' : 'c2cDirectory';
                scope.status[anotherNav + 'Show'] = false;
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    c2cDirectoryLoad: true,
                    c2cDirectoryShow: true,
                    groupDirectoryLoad: false,
                    groupDirectoryShow: false
                };
                scope.data = {

                };
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
        }
    };
}]);